module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-w-full"
  }, [_c('div', {
    staticClass: "tw-w-3/12 tw-h-[32px] tw-bg-black/5 tw-mb-2 tw-rounded"
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-w-full tw-h-[100px] tw-bg-black/5 tw-rounded tw-p-5"
  }, [_c('div', {
    staticClass: "tw-h-[43px] tw-w-full tw-flex"
  }, [_c('div', {
    staticClass: "tw-h-full tw-w-2/12 tw-animate-pulse tw-rounded tw-bg-black/10 tw-mr-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-h-full tw-w-5/12 tw-animate-pulse tw-rounded tw-bg-black/10 tw-mr-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-h-full tw-w-5/12 tw-animate-pulse tw-rounded tw-bg-black/10"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ef929c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/Skeleton/SkeletonSmall/SkeletonSmall.vue.html
// module id = NWDz
// module chunks = 2